module.exports = {
    tag: 'novice',
    quality: 0.5,
    xp_bonus: 0.05
};